export const CardsList = ({ children }) => {
  return <div className="app-ai-quote-cards-list">{children}</div>;
};
